module.exports = __webpack_public_path__ + "img/cns_email_mac10.26978097.png";